import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { addressInfoCondensedDisplayStyles } from "@insite/content-library/Components/AddressInfoCondensedDisplay";

import { css } from "styled-components";

addressInfoCondensedDisplayStyles.wrapper = mergeToNew(addressInfoCondensedDisplayStyles.wrapper, {
    css: css`
        display: flex;
        font-style: normal;
        flex-wrap: wrap;
    `,
});
addressInfoCondensedDisplayStyles.addressText = mergeToNew(addressInfoCondensedDisplayStyles.addressText, {
    as: "p",
    css: css`
        margin-right: 5px;
    `,
});
